import { render } from "./CollectionPopover.vue?vue&type=template&id=e35af47a&scoped=true"
import script from "./CollectionPopover.vue?vue&type=script&lang=js"
export * from "./CollectionPopover.vue?vue&type=script&lang=js"

import "./CollectionPopover.vue?vue&type=style&index=0&id=e35af47a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35af47a"]])

export default __exports__